import { createAsyncThunk } from '@reduxjs/toolkit'
import paymentAPI from 'services/payment'
import { PaymentAccountProps } from 'typings/paymentAccount'
import { selectAccessToken } from 'redux/authToken/authTokenSlice'
import type { OriginalRootState } from 'redux/rootReducer'
import {
  selectAccountId,
  selectUserID
} from 'redux/loginInfo/loginInfoSelectors'
import { userAccountInfo } from 'helpers/user'
import { selectActiveAccountId } from 'redux/demographic/demographicSlice'
import { DeletePaymentAccountProps } from './typings'

export const getPaymentAccountList = createAsyncThunk(
  'paymentAccountSlice/getPaymentAccountList',
  async (payload: PaymentAccountProps, { rejectWithValue }) => {
    try {
      return await paymentAPI.getPaymentAccounts(payload)
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

/**
 * Payload for paymentAccountSlice/addPaymentAccount thunk
 */
interface AddPaymentAccountPayload {
  /** Routing number entered by user */
  routingNumber: string
  /** Account number entered by user */
  accountNumber: string
  /** Nick name entered by user(optional field) */
  nickname?: string
}

export const addPaymentAccount = createAsyncThunk<
  AddPaymentAccountPayload,
  AddPaymentAccountPayload,
  {
    state: OriginalRootState
  }
>(
  'paymentAccountSlice/addPaymentAccount',
  async (
    { routingNumber, accountNumber, nickname },
    { getState, rejectWithValue }
  ) => {
    const state = getState()
    const accessToken = selectAccessToken(state)
    const userId = selectUserID(state)

    try {
      if (userAccountInfo.isProx) {
        await paymentAPI.addProxPaymentAccount({
          routingNumber,
          accountNumber,
          nickname,
          accessToken,
          userId,
          accountId: selectActiveAccountId(state)
        })
      } else {
        await paymentAPI.addBrcPaymentAccount({
          routingNumber,
          accountNumber,
          nickname,
          accessToken,
          userId,
          accountId: selectAccountId(state)
        })
      }

      return { routingNumber, accountNumber, nickname }
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const deletePaymentAccount = createAsyncThunk(
  'paymentAccountSlice/deletePaymentAccount',
  async (payload: DeletePaymentAccountProps, { rejectWithValue }) => {
    try {
      return await paymentAPI.deletePaymentAccount(payload)
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
